
<!-- eslint-disable -->
<template>
<div class="p2s2m1c2_sub_condition_entry">
    <select class="p2s2m1c2_operator_field" v-model="editComparisonOperator" @change="updateValues">
        <option value="">Please select an operator</option>
        <option value="==" >{{andText}}Received Value Equals</option>
        <option value="!=" >{{andText}}Received Value Does Not Equal</option>
        <option value=">" >{{andText}}Received Value Is Greater Than</option>
        <option value="<" >{{andText}}Received Value Is Less Than</option>
        <option value="in" >{{andText}}Received Value Contains</option>
        <option value="not in" >{{andText}}Received Value Does Not Contain</option>
    </select>
    <input class="p2s2m1c2_value_field p2s2m1_input_field" type="text" v-model="editComparisonValue" @change="updateValues" placeholder="Comparison Value">
    
    <button v-if="lastSubConditionFlag === true"
      @click="addSubCondition" class="p2s2m1c2_add_sub_condition_button">
    </button>
    <button v-if="this.subConditionIndex > 0"
      @click="removeSelf" class="p2s2m1c2_remove_sub_condition_button"
    ></button>

</div>
</template>

<script>
/* eslint-disable */

export default {
  name: "p2s2m1c2SubConditionEntry",
  props: [
    "comparisonOperator",
    "comparisonValue",
    "lastSubConditionFlag",
    "andLabelFlag",
    "conditionIndex",
    "subConditionIndex",
    "lastSubConditionFlag",
  ],
  data: function() {
    return {
      editComparisonOperator: "none",
      editComparisonValue: "",
      andText: "",
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.subConditionIndex > 0) {
        this.andText = "And ";
      }
      this.editComparisonOperator = this.comparisonOperator;
      this.editComparisonValue = this.comparisonValue;
    });
  },

  methods: {
    updateValues: function(event) {
      this.$emit("event-sub-condition-changed", [
        this.conditionIndex,
        this.subConditionIndex,
        [this.editComparisonOperator, this.editComparisonValue],
      ]);
    },
    removeSelf: function() {
      this.$emit("event-remove-sub-condition", [this.conditionIndex, this.subConditionIndex]);
    },
    addSubCondition() {
      this.$emit("event-add-sub-condition", this.conditionIndex);
    },
  },
  watch: {
    comparisonOperator() {
      this.editComparisonOperator = this.comparisonOperator;
    },
    comparisonValue() {
      this.editComparisonValue = this.comparisonValue;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2m1/p2s2m1c2SubConditionEntry.vue